"use client";

import React, { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToCollaborate() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || !contentRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.top < viewportHeight && rect.bottom > 0) {
        const centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
        const yPos = centerOffset * 0.15;
        contentRef.current.style.transform = `translateY(${yPos}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section data-section-id="182891" id="initiate-project" ref={sectionRef} className="dark bg-black text-white relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden py-20 md:py-24 shadow-[inset_0_-120px_150px_-60px_rgba(255,0,0,0.3)]">
      <div className="absolute inset-0 z-0 h-full w-full">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-40" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1616215/img/cineforge_dark_bg.png">
          <source src="https://cdn.coverr.co/videos/coverr-abstract-waves-in-the-dark-5244/1080p.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="absolute inset-0 z-10 bg-black/80" />

      <div ref={contentRef} className="relative z-20 flex w-full max-w-7xl flex-col items-center justify-center px-3 text-center">
        <h2 className="mb-8 flex flex-col items-center font-serif font-black uppercase text-white text-center tracking-[-0.04em]">
          <span className="block text-[clamp(1.1rem,6vw,3rem)] leading-[0.92]">
            Dedication Means
          </span>
          <span className="mt-2 block text-[clamp(1.1rem,6vw,3rem)] leading-[0.92]">
            Treating The 200th
          </span>
          <span className="mt-2 block text-[clamp(1.1rem,6vw,3rem)] leading-[0.92]">
            Project Like It’s The First.
          </span>
        </h2>

        <Link to="mailto:info@fanava.studio">
          <Button size="lg" className="h-14 md:h-20 rounded-none border-2 border-primary bg-transparent px-6 md:px-12 text-sm md:text-xl font-bold font-sans text-primary transition-all hover:bg-primary hover:text-black hover:scale-105 uppercase tracking-wider">
            Contact us
          </Button>
        </Link>
      </div>
    </section>;
}